import FeedbackTableRecent from "@/components/feedbackTable/page";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Box, Typography } from "@mui/material";

export const FeedbackPage = () => {
  return (
    <Box className="flex flex-col p-4 h-full">
      <Card className="w-full h-full gap-0">
        <CardHeader className="flex flex-col gap-0">
          <CardTitle>
            <Typography fontFamily={"Inter"} fontSize={"18px"} fontWeight={500}>
              Feedback
            </Typography>
          </CardTitle>
          <CardDescription>
            <Typography fontFamily={"Inter"} fontSize={"14px"} fontWeight={400}>
              Gestiona los feedbacks de la plataforma.
            </Typography>
          </CardDescription>
          <Separator className="w-full mt-4 mb-2" />
        </CardHeader>
        <CardContent>
          <Typography
            fontFamily={"Inter"}
            fontSize={"14px"}
            fontWeight={600}
            className="mt-2"
          >
            Feedback Recientes
          </Typography>
          <FeedbackTableRecent />
        </CardContent>
      </Card>
    </Box>
  );
};
